import { all } from "redux-saga/effects";
import authSagas from "./auth/saga";
import facilitySagas from "./facilities/saga";
import applianceSagas from "./Appliance/saga";
import objectCountSagas from "./objectCount/saga";
import employeeSagas from "./employee/saga";
import logSagas from "./logs/saga";

export default function* rootSaga(getState) {
  yield all([
    authSagas(),
    facilitySagas(),
    applianceSagas(),
    objectCountSagas(),
    employeeSagas(),
    logSagas(),
  ]);
}
